import { useMemo, HTMLAttributes } from 'react';
import { useLocation } from 'react-router-dom';

import useSelector from 'shared/hooks/useSelector';

import { Title } from 'components';

const PageTitle: React.FC<HTMLAttributes<HTMLHeadingElement>> = ({
  children,
  ...rest
}) => {
  const { pathname } = useLocation();
  const menuConfig = useSelector((state) => state.home.menuConfig);

  const label = useMemo(() => {
    let id = pathname.replace(/\/(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/g, '');
    let comparator = id.replace(/\//, '');

    return (
      menuConfig.find((menuItem) => comparator === menuItem.Id)?.Label || ''
    );
  }, [menuConfig, pathname]);

  return <Title {...rest}>{children || label}</Title>;
};

export default PageTitle;
